/* eslint-disable  */
//@ts-nocheck
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faClose,
  faImage,
} from '@fortawesome/pro-regular-svg-icons';

import { Accordion } from '@client/components/Accordion';
import { TextInput } from '@client/components/common/inputs/TextInput';
import { TextArea } from '@client/components/common/inputs/TextArea';
import { Button } from '@client/components/common/inputs/Button';
import { moveArray } from '@client/components/landing-page-builder/helpers';
import { FieldTitle } from '../landing-page-builder/RedStarTitle';
import { LandingMediaDropbox } from '../landing-page-builder/MediaDropBox';
import { useModal } from '../common/Modal';
import { BeforeAfterModal } from '../landing-page-builder/Modals';
import { Media } from '../../../generated/graphql';
import { CollectionProgram, MediaCover } from './collections.types';
import { upload as ajaxUpload } from '@client/components/ajax';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';

export default function ProgramReviews({
  upload,
  value,
  onChange,
  errors,
}: {
  upload?: (file: File) => Promise<MediaCover>;
  value: CollectionProgram['testimonials'];
  onChange: (xs: CollectionProgram['testimonials']) => void;
  errors: Array<{ fields: string[] }>;
}) {
  const beforeAfterPopup = useModal(BeforeAfterModal);
  const influencerId = useInfluencerId();

  const s3Upload = async (file: File) => {
    const media = await ajaxUpload(file, influencerId);

    return media as MediaCover;
  };

  const uploadFn = upload ?? s3Upload;

  const update = (i, newVal) => {
    onChange([...value.slice(0, i), newVal, ...value.slice(i + 1)]);
  };

  const remove = (i) => {
    onChange([...value.slice(0, i), ...value.slice(i + 1)]);
  };

  const move = (from, to) => {
    onChange(moveArray(value, from, to));
  };

  return (
    <>
      <ul className="text-gray-2 list-disc ml-[20px] text-h12 mb-[20px]">
        <li>
          We recommend adding at least 3 reviews before turning this section
          visible.
        </li>
        <li>Maximum of 11 reviews.</li>
      </ul>
      <div className="mt-[30px]">
        {value.map((x, i) => {
          const error = errors.find((error) => error.idx === i);
          const nameError = error?.fields.includes('name');
          const textError = error?.fields.includes('text');
          const imageError = error?.fields.includes('image');
          const videoError = error?.fields.includes('video');
          return (
            <div
              key={i}
              className="flex space-x-0 mb-4 items-start flex-col sm:flex-row sm:space-x-3"
            >
              <div className="w-[39px] h-[39px] shrink-0 rounded-lg text-lg flex items-center justify-center bg-[#E1E5F0] mb-3 sm:mb-0">
                {i + 1}
              </div>
              <Accordion
                hasError={!!error}
                title={x.name?.length ? `Review by ${x.name}` : 'Review'}
                customizations={{ padding: '20px' }}
                maxWidth="1000px"
              >
                <div className="flex">
                  <div className="w-[260px]">
                    <FieldTitle
                      title={'Name'}
                      subtitle={`• Maximum of 50 characters`}
                    />
                    <TextInput
                      value={x.name || ''}
                      onChange={(name) => update(i, { ...x, name })}
                      variant={nameError ? 'error' : 'default'}
                      inputProps={{
                        className: `w-full`,
                      }}
                      maxLength={50}
                    />
                    <div className="h-[30px]" />
                    <FieldTitle
                      title={'Testimonial'}
                      subtitle={`• Maximum of 2000 characters`}
                    />
                    <TextArea
                      error={textError}
                      value={x.text || ''}
                      onChange={(text) => update(i, { ...x, text })}
                      className="h-[180px]"
                      inputProps={{
                        className: 'resize-none',
                      }}
                      maxLength={2000}
                    />
                  </div>
                  <div className="ml-[30px]">
                    <FieldTitle
                      title={<div>Before / After Photo</div>}
                      showTooltip={() => beforeAfterPopup.open()}
                    />
                    <LandingMediaDropbox
                      upload={uploadFn}
                      label={null}
                      validationText="You can create beautiful before/after photos using our guide here."
                      value={toImageUrl(x.media)}
                      onChange={(media) => update(i, { ...x, media })}
                      type="image"
                      icon={faImage as any}
                      variant="white"
                      errorMsg={imageError ? 'This field is required' : ''}
                    >
                      <ul className="text-black list-none text-center text-h12">
                        <li>JPG File</li>
                        <li>Square image</li>
                      </ul>
                    </LandingMediaDropbox>
                  </div>
                </div>
              </Accordion>

              <div className="flex items-center h-[39px] pl-[28px]">
                <div className="w-[40px]">
                  {i > 0 && value.length > 1 ? (
                    <FontAwesomeIcon
                      icon={faChevronUp as any}
                      onClick={() => move(i, i - 1)}
                      className="-mb-0.5 cursor-pointer"
                    />
                  ) : null}
                </div>
                <div className="w-[40px]">
                  {i < value.length - 1 && value.length > 1 ? (
                    <FontAwesomeIcon
                      icon={faChevronDown as any}
                      onClick={() => move(i, i + 1)}
                      className="cursor-pointer"
                    />
                  ) : null}
                </div>
                <div className="w-[40px]">
                  <FontAwesomeIcon
                    icon={faClose as any}
                    onClick={() => remove(i)}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          );
        })}
        {value.length < 11 ? (
          <Button
            onClick={() =>
              onChange([...value, { name: '', text: '', media: null }])
            }
          >
            Add Program Review
          </Button>
        ) : null}
      </div>
      <beforeAfterPopup.Popup />
    </>
  );
}

function toImageUrl(media: Media) {
  if (!media) return '';
  return media.cdn01 + media.image;
}
